import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';

import Catalogo from '../../components/Catalogo';
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import * as catalogoService from "../../services/catalogoService";
import { setEntity, activeValidations } from '../../redux/catalogSlice';

const Edit = (props) => {
    const sliceKey = "catalogEdit";
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("catalogo");

    const entity = useSelector((state) => state.catalog[sliceKey]?.entity) || {};
    const validation = useSelector((state) => state.catalog[sliceKey]?.validationMessage) || [];

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });

    useEffect(() => {
        if (params.id == 0) {
            dispatch(setEntity({ sliceKey: sliceKey, data: { idCatalogo: 0, codigo: "", descripcion: "", abreviado: "", orden: 0, idPadre: 0, descripcionPadre: "", estado: "A" } }));
        }
    }, [params.id]);

    const postEntity = async () => {
        if (validation.length > 0) {
            dispatch(activeValidations({ sliceKey: sliceKey }));
            setPropsMessage({ severity: "error", message: validation.join(" - ") })
            setOpenMessage(true);
            return;
        }

        await catalogoService.addUpdateCatalogo({
            idCatalogo: entity.idCatalogo || 0,
            codigo: entity.codigo || "",
            descripcion: entity.descripcion || "",
            abreviado: entity.abreviado || "",
            orden: entity.orden || 0,
            idPadre: entity.idPadre || 0,
            estado: entity.estado || "A",
        })
            .then((idCatalogo) => {
                dispatch(setEntity({ sliceKey: sliceKey, data: { ...entity, idCatalogo: idCatalogo } }));
                setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
                setOpenMessage(true);
                setIsReadOnly(true);

                if (params.id == 0 && idCatalogo > 0) {
                    navigate("/catalog/edit/" + idCatalogo);
                }
            })
            .catch(() => {
                setPropsMessage({ severity: "error", message: "Hubo un error" })
                setOpenMessage(true);
            });
    }

    return (
        <div>
            <MantenimientoForm
                title={(params.id == 0 ? "Nuevo" : "Editar") + " Catalogo"}
                backTo={"/catalog"}
                onSave={postEntity}
                disabled={isReadOnly}
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <Catalogo sliceKey={sliceKey} isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                    {propsMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Edit;